const LS_OTHER_TAB_API_RESPONSE = 'LS_OTHER_TAB_API_RESPONSE'
const STORAGE_KEY_API_TIME = 'lastApiResponseTime'
const STORAGE_KEY_TAB_ID = 'lastApiResponseTabId'
const monitoredKeys = new Set([STORAGE_KEY_API_TIME])
const tabId = (new Date()).toISOString()

/**
 * Registers storage event listener and dispatches actions when the state gets changed in different tabs.
 * Based on https://github.com/darthmaim/redux-sync-reducer
 */
export const localStorageMiddleware = (store) => {
  window.addEventListener('storage', e => {
    if (!monitoredKeys.has(e.key)) {
      return
    }

    const otherTabId = JSON.parse(window.localStorage.getItem(STORAGE_KEY_TAB_ID))
    const value = JSON.parse(e.newValue)

    store.dispatch({
      type: LS_OTHER_TAB_API_RESPONSE,
      value: value,
      oldValue: e.oldValue,
      tabId: otherTabId,
    })
  })

  return next => action => next(action)
}

/**
 * Set STORAGE_KEY_API_TIME value in local Store (specific timestamp in ISO format, null or current time by default)
 * time = null for sign out
 */
export const setLastApiResponseTime = (time) => {
  let lastApiResponseTime = time
  if (typeof time === 'undefined') {
    lastApiResponseTime = (new Date()).toISOString()
  }

  window.localStorage.setItem(STORAGE_KEY_TAB_ID, JSON.stringify(tabId))
  window.localStorage.setItem(STORAGE_KEY_API_TIME, JSON.stringify(lastApiResponseTime))
}

export default {
  setLastApiResponseTime,
  LS_OTHER_TAB_API_RESPONSE,
}
